import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Impressum() {
  return (
    <>
      <Header />
      <main className="pt-28 pb-20 bg-white">
        <div className="max-w-3xl mx-auto px-5">
          <h1 className="text-4xl font-heading font-extrabold text-spin-dark mb-2">Impressum</h1>
          <hr className="section-divider" style={{ marginLeft: 0 }} />

          <div className="text-spin-grey leading-relaxed space-y-6">
            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">
                Angaben gemäß § 5 TMG
              </h2>
              <p>
                Zeitfrei GmbH<br />
                Hasberger Str. 9 c<br />
                87757 Kirchheim<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">
                Vertreten durch
              </h2>
              <p>Geschäftsführerin: Drita Schneider</p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">Kontakt</h2>
              <p>
                Telefon: +49 8266 8612-12<br />
                E-Mail:{' '}
                <a href="mailto:info@spinsafe.de" className="text-spin-green hover:underline">
                  info@spinsafe.de
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">
                Registereintrag
              </h2>
              <p>
                Eintragung im Handelsregister<br />
                Registergericht: Amtsgericht Memmingen<br />
                Registernummer: HRB 19482
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p>
                Drita Schneider<br />
                Hasberger Str. 9 c<br />
                87757 Kirchheim
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">
                Streitschlichtung
              </h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
                bereit:{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-spin-green hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br />
                Unsere E-Mail-Adresse findest du oben im Impressum. Wir sind nicht bereit oder
                verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">
                Haftung für Inhalte
              </h2>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
                als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">
                Haftung für Links
              </h2>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
                keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
                Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
                Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-spin-dark mb-2">Urheberrecht</h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
